import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import MunikLogo from "../../atoms/MunikLogo";
import PssLogo from "../../atoms/pssLogo";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";
import { logout } from "../../../firebase/firebaseutils";
import useMediaQuery from "@mui/material/useMediaQuery";

const Navbar = () => {
  const classes = useStyles();
  let sm = useMediaQuery("(max-width:500px)");
  const res = useContext(AppContext);
  let navigate = useNavigate();

  const setUser = res?.appLoadingStates?.setUser;
  const user = res?.appLoadingStates?.user;

  const handleSignout = () => {
    logout();
    // if (signout) {
    setUser("");
    localStorage.clear();
    navigate("/");
    // }
  };
  return (
    <Box className={classes.root}>
      <Box
        sx={{
          marginLeft: "50px",
          cursor: "pointer",
        }}
      >
        <MunikLogo />
      </Box>

      {user ? (
        <div style={{ display: "flex" }}>
          <Link
            to="/contact-info"
            style={{ textDecoration: "none", color: "black" }}
          >
            <h3
              style={{
                cursor: "pointer",
                marginRight: "30px",
                fontSize: sm ? "15px" : "18px",
              }}
            >
              Contact Info
            </h3>
          </Link>
          <h3
            style={{
              marginRight: "50px",
              cursor: "pointer",
              fontSize: sm ? "15px" : "18px",
            }}
            onClick={handleSignout}
          >
            Logout
          </h3>
        </div>
      ) : (
        <Box
          sx={{
            marginRight: "50px",
            cursor: "pointer",
          }}
        >
          <PssLogo />
        </Box>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: "15vh",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  pssLogoStyles: {},
  munikLogoStyles: {
    marginLeft: "50px",
    cursor: "pointer",
  },
}));

export default Navbar;
